import constants from '@/js/constants';

export default {
  data() {
    return {
      laneHeaderHeight: 0,
      resizeObserver: null,
    };
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  computed: {
    isKanbanMode() {
      return this.$store.state.ui.planning.mode == 'kanban';
    },
    laneContentHeight() {
      this.laneElements.map(el => el.height); // reactive to el height
      this.lane.contentHeight = this.$store.getters['planning/lanes/getLaneContentHeight'](this.lane.id);
      return this.lane.contentHeight;
    },
    laneHeight() {
      if (! this.laneHeaderHeight) this.updateLaneHeaderHeight();
      this.lane.height = Math.max(this.laneContentHeight, this.laneHeaderHeight);
      return this.lane.height;
    },
    kanbanLaneHeaderMinHeight() {
      const laneMinHeight = constants.laneMinHeight + constants.lanePadding + 1;
      return Math.max(laneMinHeight, this.laneHeaderHeight);
    },
    laneHeaderHeightReactiveProperties() {
      return { label: this.lane.label, monitoringplan: this.lane.monitoringplan, hidden: this.lane.hidden };
    },
  },
  watch: {
    laneHeaderHeightReactiveProperties: {
      handler() { this.updateLaneHeaderHeight(); },
      deep: true,
    },
  },
  methods: {
    updateLaneHeaderHeight() {
      this.$nextTick(() => {
        this.laneHeaderHeight = this.$store.getters['planning/lanes/getLaneHeaderHeight'](this.lane.id);
      });
    },
    createLaneHeightObserver() {
      if (! this.laneHeaderHeight) this.updateLaneHeaderHeight();
      const laneContent = document.getElementById(`lane${this.lane.id}`);
      if (! laneContent) return;
      this.resizeObserver = new ResizeObserver(() => {
        if (this.isKanbanMode) {
          this.lane.height = laneContent.offsetHeight;
        }
      });
      this.resizeObserver.observe(laneContent);
    },
  },
};
